// page-archives ページのjs

import "../sass/page-past-exhibitions.scss";

const YEAR_PATTERN = /(20\d{2})/;
const PAST_START_YEAR = 2024;

const createYearButton = (year) => {
	const button = document.createElement("button");
	button.type = "button";
	button.className = "past-year-filter-option js-past-year-option";
	button.dataset.year = year;
	button.textContent = `${year}年`;
	button.setAttribute("aria-pressed", "false");
	return button;
};

const initPastYearFilter = () => {
	const root = document.querySelector(".js-past-year-filter");
	const sections = [...document.querySelectorAll("main section[id]")].filter((section) => YEAR_PATTERN.test(section.id));

	if (!root || sections.length === 0 || root.dataset.yearFilterInitialized === "true") {
		return;
	}

	const toggleButton = root.querySelector(".js-past-year-toggle");
	const label = root.querySelector(".js-past-year-label");
	const panel = root.querySelector(".js-past-year-panel");

	if (!toggleButton || !label || !panel) {
		return;
	}

	const years = [...new Set(sections.map((section) => section.id))]
		.map((year) => Number.parseInt(year, 10))
		.filter((year) => year >= PAST_START_YEAR)
		.sort((leftYear, rightYear) => rightYear - leftYear)
		.map((year) => `${year}`);

	if (years.length === 0) {
		return;
	}

	const yearButtons = years.map((year) => createYearButton(year));
	panel.replaceChildren(...yearButtons);

	const sectionIds = new Set(sections.map((section) => section.id));

	const updateVisibleSection = (selectedYear) => {
		sections.forEach((section) => {
			section.toggleAttribute("hidden", section.id !== selectedYear);
		});
	};

	const closePanel = () => {
		root.classList.remove("is-open");
		toggleButton.setAttribute("aria-expanded", "false");
		panel.hidden = true;
	};

	const openPanel = () => {
		root.classList.add("is-open");
		toggleButton.setAttribute("aria-expanded", "true");
		panel.hidden = false;
	};

	const updateSelectedYear = (selectedYear) => {
		label.textContent = `${selectedYear}年`;
		yearButtons.forEach((button) => {
			const isCurrent = button.dataset.year === selectedYear;
			button.classList.toggle("is-current", isCurrent);
			button.setAttribute("aria-pressed", `${isCurrent}`);
		});
		updateVisibleSection(selectedYear);
	};

	let initialYear = years[0];
	if (!sectionIds.has(initialYear)) {
		const [initialAvailableYear] = years;
		initialYear = initialAvailableYear;
	}

	updateSelectedYear(initialYear);
	root.dataset.yearFilterInitialized = "true";

	toggleButton.addEventListener("click", () => {
		if (panel.hidden) {
			openPanel();
			return;
		}

		closePanel();
	});

	panel.addEventListener("click", (event) => {
		const clickedButton = event.target.closest(".js-past-year-option");
		if (!(clickedButton instanceof HTMLButtonElement)) {
			return;
		}

		const { year: selectedYear } = clickedButton.dataset;
		if (!sectionIds.has(selectedYear)) {
			return;
		}

		updateSelectedYear(selectedYear);
		closePanel();
	});

	document.addEventListener("click", (event) => {
		if (panel.hidden || root.contains(event.target)) {
			return;
		}

		closePanel();
	});

	document.addEventListener("keydown", (event) => {
		if (event.key !== "Escape" || panel.hidden) {
			return;
		}

		closePanel();
		toggleButton.focus();
	});
};

// htmx完了ポーリング
const watchInterval = setInterval(() => {
	const { body } = document;
	if (body && body.classList.contains("htmx-settled")) {
		clearInterval(watchInterval);
		initPastYearFilter();
	}
}, 100);
